import type { CommonTrackingData } from '~/types/tracking'
import type { UseStateType } from '~/types/utils/use-state-type'

// This is used to extract the right types from Nuxt useState
type Types = UseStateType<CommonTrackingData>
const defaultInit = (): Types['state'] => ({
  page: 'Main page',
  pageTitle: 'Main',
})

/**
 * Use this composable to get CommonTrackingData State
 *
 * (A type-safe wrapper around `useState`)
 */
export const useCommonTrackingDataState = (): Types['return'] =>
  useState<Types['state']>('common-tracking-data', defaultInit)

/**
 * Use this composable to set/change CommonTrackingData state
 */
export const useSyncCommonTrackingDataState = (
  commonTrackingData: Ref<CommonTrackingData>,
): void => {
  const currentData = useCommonTrackingDataState()

  watch(
    commonTrackingData,
    () => {
      currentData.value = Object.assign(
        currentData.value,
        commonTrackingData.value,
      )
    },
    { immediate: true },
  )
}
